export default __webpack_public_path__ + "static/media/client_dee.bd86c504.jpeg";